<template>
  <div class="ht200-monitor_alarm">
    <div class="top">
      <div class="alarm-header">
        <div
          :class="['alarm-icon', 'iconfont', alarmIcon.icon]"
          :style="{ '--alarm-color': alarmIcon.color }"
        ></div>
        <div class="alarm-info">
          <div class="alarm-text">{{ alarmText }}</div>
          <div class="alarm-material">{{ $t('物质名称') }}：{{ alarmMatName || '--' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from '@/utils/is';
import { alarmDict, HT200StatusUtil, makeLineOptions } from '../utils/index';

export default {
  inject: ['getRoot'],
  data() {
    return {
      state: HT200StatusUtil.getStateByText('报警'),
      model: {
        materialName: '',
        concentration: '',
        materalCode: '',
        matLibType: ''
      },
      options: makeLineOptions(),
      list: [
        {
          label: '物质名称',
          prop: 'materialName'
        },
        {
          label: '物质浓度',
          prop: 'concentration'
        },
        {
          label: '物质代码',
          prop: 'materalCode'
        },
        {
          label: '物质库类型',
          prop: 'matLibType'
        },
        {
          label: '运行状态',
          prop: 'runstate'
        },
        {
          label: '配置电场模式',
          prop: 'confgurationMode'
        },
        {
          label: '当前电场模式',
          prop: 'currentMode'
        },
        {
          label: '对齐因子',
          prop: 'factor'
        }
      ]
    };
  },
  computed: {
    alarmData() {
      const root = this.getRoot();

      const data = root.j218StateData?.subsReportDto;

      return data;
    },
    alarmText() {
      return this.alarmData?.typeName;
    },
    alarmIcon() {
      const { typeCode } = this.alarmData || {};

      if (isEmpty(typeCode)) return {};

      return alarmDict.enum[typeCode];
    },
    alarmMatName() {
      return this.alarmData?.name;
    }
  },
  methods: {},
  mounted() {}
};
</script>

<style lang="scss">
.ht200-monitor_alarm {
  height: 100%;

  --top-height: 30%;
  --bottom-height: 70%;

  .top {
    --mb: 20px;
    --color: #e94239;

    color: var(--color);
    border: 2px solid var(--color);
    border-radius: 12px;
    background: linear-gradient(135deg, rgba(233, 66, 57, 0.1) 0%, rgba(233, 66, 57, 0.02) 100%);
    box-shadow: 0 0 20px rgba(233, 66, 57, 0.15), inset 0 0 30px rgba(233, 66, 57, 0.05);

    height: calc(var(--top-height) - var(--mb));
    margin-bottom: var(--mb);

    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px;

    .alarm-header {
      display: flex;
      align-items: center;
      gap: 32px;

      .alarm-icon {
        font-size: 60px;
        color: #fff;
        background: var(--alarm-color);
        border-radius: 50%;
        width: 80px;
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        box-shadow: 0 6px 20px rgba(233, 66, 57, 0.4);
        animation: pulse-alarm 2s ease-in-out infinite;
      }

      .alarm-info {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .alarm-text {
          font-size: 32px;
          font-weight: bold;
          letter-spacing: 3px;
          text-shadow: 0 2px 4px rgba(233, 66, 57, 0.3);
          animation: text-glow 2s ease-in-out infinite;
        }

        .alarm-material {
          font-size: 20px;
          opacity: 0.9;
          padding: 8px 16px;
          background: rgba(233, 66, 57, 0.1);
          border-radius: 6px;
          border-left: 3px solid var(--alarm-color);
        }
      }
    }
  }

  .bottom {
    height: var(--bottom-height);
  }
}

@keyframes pulse-alarm {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 6px 20px rgba(233, 66, 57, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 8px 25px rgba(233, 66, 57, 0.6);
  }
}

@keyframes text-glow {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.85;
  }
}
</style>
